import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from '../i18n/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet relative overflow-hidden" data-id="element-46">
      <div className="gold-spotlight-center" aria-hidden="true" data-id="element-47" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="surface-elevated max-w-4xl mx-auto p-10 md:p-16 rounded-sm" data-id="element-49">
          <h2 className="gold-shine font-script font-semibold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight" data-id="element-50">
            {t.finalCta.title1}
            <span className="font-allura font-normal text-5xl md:text-6xl lg:text-7xl align-middle mx-1" data-id="element-51">
              {t.finalCta.titleHighlight}
            </span>{' '}
            {t.finalCta.title2}
          </h2>

          <p className="font-sans font-normal text-lg md:text-xl text-riam-gold-light/90 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-52">
            {t.finalCta.p1}
            <br data-id="element-53" />
            <br data-id="element-54" />
            {t.finalCta.p2}
            <br data-id="element-55" />
            <br data-id="element-56" />
            {t.finalCta.p3_1}
            <span className="font-allura font-normal text-3xl md:text-4xl align-middle mx-1" data-id="element-57">
              {t.finalCta.p3_highlight}
            </span>
            {t.finalCta.p3_2}
          </p>

          <div className="mb-10" data-id="element-58">
            <Button href="https://beautybyriam.booksy.com" className="text-lg px-10 py-5 font-sans font-semibold tracking-wider" data-id="element-59">
              {t.finalCta.cta}
            </Button>
          </div>

          <p className="gold-shine-soft font-script font-semibold italic text-2xl md:text-3xl" data-id="element-60">
            {t.finalCta.quote_1}
            <span className="font-allura font-normal text-4xl md:text-5xl align-middle ml-1" data-id="element-61">
              {t.finalCta.quote_highlight}
            </span>
            {t.finalCta.quote_2}
          </p>
          <p className="font-allura text-3xl md:text-4xl text-riam-gold/60 mt-8" data-id="element-62">
            Riam Beauty Studio
          </p>
        </motion.div>
      </div>
    </section>;
}